var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 29.3327C23.8337 29.3327 29.8337 23.3327 29.8337 15.9993C29.8337 8.66602 23.8337 2.66602 16.5003 2.66602C9.16699 2.66602 3.16699 8.66602 3.16699 15.9993C3.16699 23.3327 9.16699 29.3327 16.5003 29.3327Z",
    fill: "#009E10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 15.9999L14.6063 19.7732L22.1663 12.2266",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessCheckCircleIcon);
export default __webpack_public_path__ + "static/media/access-check-circle-icon.e13f5a8b3d3275e0d0f101844c2958bd.svg";
export { ForwardRef as ReactComponent };